import React from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import MessageUI from './MessageUI'
import './PageTitle.css'

const PageTitleUI = ({context, history, goBack, backLink, messageList,
  titleText, titleMessageKey, titleMessageArgs, subTitleText}) =>
  <div className='w_pg_title g_flex_h'>
    {
      goBack && !backLink &&
      <Link className="backLink" to='#back' onClick={() => history.goBack()}>
        <div className="icon icon-caret-left"></div>
      </Link>
    }
    {
      goBack && backLink &&
      <Link className="backLink" to={backLink}>
        <div className="icon icon-caret-left"></div>
      </Link>
    }

    {
      titleText &&
      <span className='g_m_left_100 g_large g_m_bottom_50'><b>{titleText}</b></span>
    }
    {
      titleMessageKey &&
      <h2>
        <MessageUI messageList={messageList} messageKey={titleMessageKey} args={titleMessageArgs} />
        {
          subTitleText &&
          <span className='g_muted g_normal g_m_left_50'>{subTitleText}</span>
        }
      </h2>
    }
  </div>

export default withRouter(PageTitleUI)
